export const SHOP_SESSION_FLAGS_SESSION_STORAGE = 'shopSessionFlags'

export const initialShopSessionFlags = {
  confirmedAddress: false,
  isCartOOSExpanded: true,
  showFlexibleWindowBanner: true,
} satisfies Record<string, boolean>

export type ShopSessionFlagKey = keyof typeof initialShopSessionFlags
